import { addShortcodeToEditor, getShortcodeWrapper } from "@/assets/utilities/tinymce/shortodeAddition";
import { getToastTemplate } from "@/assets/utilities/tinymce/shortcodes/templates";
import { parseToHtml } from "@/utility/parseToHtml";
import { TOAST_INITIAL_TIME } from "@/constant/index";

const editToastConfig = (editor, shortcodeWrapper) => {
  let currentData = null;
  let initialTime = null;

  const toastWindow = editor.windowManager.openUrl({
    title: "Toast",
    url: "/toast-dialog",
    buttons: [
      {
        type: "cancel",
        name: "close",
        text: "Cancel",
      },
      {
        type: "custom",
        name: "submit",
        text: "Submit",
        primary: true,
      },
    ],
    onAction: function (instance, message) {
      editor.windowManager.alert("Success!");
      shortcodeWrapper.setAttribute("data-toast-data", currentData);
      shortcodeWrapper.setAttribute("data-initial-time", initialTime);
      // We have to call change function here to updateMainContent in form component
      editor.fire("change");
      instance.close();
    },
    onMessage: (instance, message) => {
      if (message.mceAction === "requestData") {
        sendData();
      }

      if (message.mceAction === "updateToastData") {
        currentData = message.data;
      }

      if (message.mceAction === "updateInitialTime") {
        initialTime = message.time;
      }
    },
    width: window.innerWidth - 20,
    height: window.innerHeight - 20,
  });

  const sendData = () => {
    toastWindow.sendMessage({
      type: "sendData",
      data: shortcodeWrapper.getAttribute("data-toast-data"),
      time: shortcodeWrapper.getAttribute("data-initial-time"),
    });
  };
};

const toastConfig = (tinymce, uuid, shortcodeOnClick) => {
  let currentData = null;
  let initialTime = TOAST_INITIAL_TIME;

  tinymce.activeEditor.windowManager.openUrl({
    title: "Toast",
    url: "/toast-dialog?data=null&time=null",
    buttons: [
      {
        type: "cancel",
        name: "close",
        text: "Cancel",
      },
      {
        type: "custom",
        name: "submit",
        text: "Submit",
        primary: true,
      },
    ],
    onAction: function (instance) {
      const shortcodeWrapper = getShortcodeWrapper(uuid, shortcodeOnClick, getToastTemplate(), "toast-shortcode");
      const shortcodeWrapperEl = parseToHtml(shortcodeWrapper).querySelector(".shortcode");

      shortcodeWrapperEl.setAttribute("data-toast-data", currentData);
      shortcodeWrapperEl.setAttribute("data-initial-time", initialTime);
      addShortcodeToEditor(shortcodeWrapperEl.outerHTML, uuid);
      instance.close();
    },
    onMessage: (instance, message) => {
      if (message.data) {
        currentData = message.data;
      }

      if (message.time) {
        initialTime = message.time;
      }
    },
    width: window.innerWidth - 20,
    height: window.innerHeight - 20,
  });
};

export { toastConfig, editToastConfig };
